import FormPropertyListingInfo from './FormPropertyListingInfo';

export default FormPropertyListingInfo;
